import { createFileRoute } from '@tanstack/react-router'
import { TaskInventory } from '../pages/TaskInventory'

export const Route = createFileRoute('/task-inventory')({
  component: TaskInventory,
})
